module.exports = __webpack_public_path__ + "img/phone.7d13c0a6.svg";